export const UIModes = {
  LIGHT: "LIGHT",
  DARK: "DARK",
};
